import { render, staticRenderFns } from "./HmFilterMSGoods.vue?vue&type=template&id=2a768b3d&scoped=true&"
import script from "./HmFilterMSGoods.vue?vue&type=script&lang=js&"
export * from "./HmFilterMSGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a768b3d",
  null
  
)

component.options.__file = "HmFilterMSGoods.vue"
export default component.exports